import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class EncryptionStorageService {

  constructor(private configService: ConfigService) {}

  private get secretKey(): string {
    return this.configService.get('encryptionKey');
  }
  private readonly storageKey = '_tr_v1'; // single encrypted object in localStorage

  // Encrypt data
  private encrypt(value: any): string {
    return CryptoJS.AES.encrypt(JSON.stringify(value), this.secretKey).toString();
  }

  // Decrypt data
  private decrypt(value: string): any {
    try {
      if (!value || !this.secretKey) {
        console.error('Missing value or secretKey', { value, secretKey: this.secretKey });
        return {};
      }
  
      const bytes = CryptoJS.AES.decrypt(value, this.secretKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  
      if (!decrypted) {
        console.error('Decryption failed: Empty result');
        return {};
      }
  
      return JSON.parse(decrypted);
    } catch (err) {
      console.error('Decryption error:', err);
      return {};
    }
    
  }
  

  // Load whole object from storage
  private loadData(): Record<string, any> {
    const encrypted = localStorage.getItem(this.storageKey);
    if (!encrypted) return {};
    return this.decrypt(encrypted) || {};
  }

  // Save whole object back
  private saveData(data: Record<string, any>): void {
    const encrypted = this.encrypt(data);
    localStorage.setItem(this.storageKey, encrypted);
  }

  // Public API
  setItem(key: string, value: any): void {
    const data = this.loadData();   // 👈 always load full object
    data[key] = value;              // update / add key
    this.saveData(data);            // save encrypted object back
  }

  getItem(key: string): any {
    const data = this.loadData();
    return data[key] ?? null;
  }

  removeItem(key: string): void {
    const data = this.loadData();
    delete data[key];
    this.saveData(data);
  }

  clear(): void {
    localStorage.removeItem(this.storageKey);
  }

  getAll(): Record<string, any> {
    return this.loadData();
  }
}
